export enum WARRANTY_TYPE {
  DEVICE,
  SPAREPART,
  SPAREPART_WITH_DEVICE,
}
